const url = process.env.VUE_APP_API_URL

let getPrograms = async () => {
    return fetch(url, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
        },
        body: JSON.stringify({ query: "{ allPrograms {code, title} }" }),
    })
        .then(response => response.json())
        .then(response => response.data.allPrograms)
}
let getProgram = async (year, code) => {
    return fetch (url, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
        },
        body: JSON.stringify({ query: `{
            program(code: "${code}") {
              code
              title
              description
              thumb
              products(year: ${year}) {
                year
                code
                title
                activities {
                  code
                  title
                  results {
                    title
                    date
                    quantity
                    bundle_id
                    url
                    type
                  }
                  indicator {
                    name
                  }
                }
              }
            }
            yearsByProgram(code:"${code}")
          }` }),
    })
        .then(response => response.json())
        .then(response => response.data)
}
let getYearsByProgram = async (code) => {
    return fetch (url, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
        },
        body: JSON.stringify({ query: `{
            yearsByProgram(code:"${code}")
          }` }),
    })
        .then(response => response.json())
        .then(response => response.data.yearsByProgram)
}
let getTimeline = async () => {
    return fetch (url, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
        },
        body: JSON.stringify({ query: `{
            timeline {
                year
                programs {
                    code
                    title
                }
            }
        }`})
    }) 
    .then(response => response.json())
    .then(response => response.data)
}
export {
    getPrograms,
    getProgram,
    getYearsByProgram,
    getTimeline
}